import React, { useEffect } from 'react';
import { Grid, Box } from '@mui/material';
import CustomTextField from '../../../../components/CustomTextField/CustomTextField';

type BiographyFieldProps = {
  biography?: string;
};
const BiographyField = (props: BiographyFieldProps) => {
  const { biography } = props;

  const [biographyValue, setBiographyValue] = React.useState(biography || '');

  useEffect(() => {
    setBiographyValue(biography || '');
  }, [biography]);

  return (
    <Grid display={'flex'} gap={5} flexDirection={'column'} p={5}>
      <Grid item xs={12} sm={6} display={'flex'} flexDirection={'column'}>
        <label
          htmlFor='biography'
          style={{
            fontWeight: 700,
            fontSize: '18px',
            color: '#000000',
            marginLeft: '10px',
          }}>
          Biography
        </label>
        <Grid display={'flex'} gap={2} alignItems={'center'} flex={1}>
          <Box sx={{ flexGrow: 1 }}>
            <CustomTextField
              name='biography'
              sx={{ width: '100%', maxWidth: '654px' }}
              value={biographyValue}
              // defaultValue={"firstName" || ""}
              onChange={() => {}}
            />
          </Box>
        </Grid>
      </Grid>
    </Grid>
  );
};

export default BiographyField;
